import { fromJS, OrderedSet } from "immutable";

import types from "./types";

export const initialState = fromJS({
  ids: OrderedSet(),
  byId: {},
  total: null,
  hasFetched: false,
  error: null,
});

const updateCampaigns = (state, campaigns) => {
  return campaigns.reduce((campaignsState, currentCampaign) => {
    const currentCampaignId = currentCampaign.id.toString();

    if (state.get("ids").includes(currentCampaignId)) {
      const previousCampaignState = state.getIn(["byId", currentCampaignId]);

      if (previousCampaignState) {
        return campaignsState.set(currentCampaignId, fromJS(currentCampaign));
      } else {
        return campaignsState;
      }
    } else {
      return campaignsState.set(currentCampaignId, fromJS(currentCampaign));
    }
  }, state.get("byId"));
};

const mergeIds = (ids, newIds) => ids.union(newIds);

const extractIds = (campaigns) => {
  return campaigns.reduce((set, campaign) => {
    return set.add(campaign.id.toString());
  }, OrderedSet());
};

const updateCampaignsState = (state, action) => {
  let newCampaignIds = extractIds(action.campaigns);

  let allCampaignIds = mergeIds(state.get("ids"), newCampaignIds);

  let updatedCampaigns = updateCampaigns(state, action.campaigns);

  return state.withMutations((state) => {
    state
      .set("byId", updatedCampaigns)
      .set("ids", allCampaignIds)
      .set("total", action.total)
      .set("error", null)
      .set("hasFetched", true);
  });
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.INITIAL_FETCH: {
      return state.set("initialFetch", true);
    }

    case types.SET_ERROR: {
      return state.set("error", action.error);
    }

    case types.RECEIVED_CAMPAIGNS: {
      return updateCampaignsState(state, action);
    }

    case types.RESET_AND_ADD_NEW_CAMPAIGNS: {
      return updateCampaignsState(initialState, action);
    }

    case types.RESET_CAMPAIGNS: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};
